// src/components/StoryCard.js

import React, { useEffect, useMemo, useRef } from "react";
import { Card, CardMedia, CardContent, Typography, Box } from "@mui/material";
import dayjs
    from "dayjs";
const StoryCard = ({ mediaUrl, isVideo, description, isMobile, isTopCard, createdAt }) => {
    const videoProps = isVideo
        ? {
            component: "video",
            // autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            src: mediaUrl,
        }
        : {
            component: "img",
            image: mediaUrl,
            alt: "Story media",
        };

    const videoRef = useRef(null);

    // Example: 32 Jan 2022
    const formattedDate = useMemo(() => dayjs(createdAt).format("DD MMMM YYYY"), [createdAt]);

    useEffect(() => {
        if (isVideo && videoRef.current) {
            if (isTopCard) {
                videoRef.current.play(); // Play when it's the top card
            } else {
                videoRef.current.pause(); // Pause otherwise
            }
        }
    }, [isTopCard, isVideo]);

    return (
        <Card
            sx={{
                // border: `2px solid rgba(0, 0, 0, 0.3)`,
                borderRadius: 2,
                overflow: "hidden",
                width: "100%",
                height: "100%",
                position: "relative", // Ensure absolute positioning works inside
            }}
        >
            {/* Background Media */}
            <CardMedia
                ref={videoRef}
                draggable="false"
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                }}
                {...videoProps}
            />

            {/* Overlay Create Date At Top */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    background: "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%)",
                    color: "#fff", // White text for contrast
                    px: "16px",
                    py: "8px",
                    textAlign: "left",
                }}
            >
                <Typography
                    variant="caption"
                    sx={{ fontWeight: "medium" }}
                >
                    {formattedDate}
                </Typography>
            </Box>

            {/* Overlay Description At Bottom */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
                    color: "#fff", // White text for contrast
                    padding: "16px",
                    textAlign: "left",
                }}
            >
                <Typography
                    variant="body2"
                    sx={{ fontWeight: "medium" }}
                >
                    {description}
                </Typography>
            </Box>
        </Card>
    );
};

export default StoryCard;
